




































  import Routes from '@/router/routes';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'DemandeType',
    computed: {
      routeCreerDemande() {
        return Routes.CreerDemandeCreationCours;
      },
      routeCreerDemandeModification() {
        return Routes.CreerDemandeModificationCours;
      },
      routeCreerDemandeReactivation() {
        return Routes.CreerDemandeReactivationCours;
      },
      routeCreerDemandeDesactivation() {
        return Routes.CreerDemandeDesactivationCours;
      },
      routeCreerDemandeModificationProgramme() {
        return Routes.CreerDemandeModificationProgramme;
      },
      breadcrumbsItems(): Array<unknown> {
        return [
          {
            disabled: false,
            text: this.$i18n.t(
              'demande.formulaires.navigation-liste-de-demandes'
            ),
            exact: true,
            to: { name: Routes.Demandes },
          },
          {
            text: this.$i18n.t('demande.type.titre'),
          },
        ];
      },
    },
  });
